var _defs, _g, _g2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    zoomAndPan: "magnify",
    viewBox: "0 0 36 36.000001",
    height: 48,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d551e040dd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1.75 0.652344 L 34.589844 0.652344 L 34.589844 34.949219 L 1.75 34.949219 Z M 1.75 0.652344 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cd842d357b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 17 0.652344 L 34.589844 0.652344 L 34.589844 34.949219 L 17 34.949219 Z M 17 0.652344 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d551e040dd)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e23237",
    d: "M 1.792969 6.339844 L 17.953125 0.652344 L 34.542969 6.238281 L 31.859375 27.351562 L 17.953125 34.957031 L 4.265625 27.453125 Z M 1.792969 6.339844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cd842d357b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b52e31",
    d: "M 34.542969 6.238281 L 17.953125 0.652344 L 17.953125 34.957031 L 31.859375 27.363281 Z M 34.542969 6.238281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 17.976562 4.660156 L 7.910156 26.78125 L 11.671875 26.71875 L 13.691406 21.730469 L 22.722656 21.730469 L 24.9375 26.78125 L 28.53125 26.84375 Z M 18.003906 11.746094 L 21.40625 18.769531 L 15.011719 18.769531 Z M 18.003906 11.746094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/Angular.526863fceb93af2edd890f8a8aba6589.svg";
export { ForwardRef as ReactComponent };